import React, { Component } from "react";
import cx from "classnames";
import distanceInWordsToNow from "date-fns/distance_in_words_to_now";

import Screen from "./ConnectedScreen";
import Tabs from "../components/Tabs";
import Message from "../components/Message";
import { MODELS_TABS } from "../components/ModelListScreen";

class VideosScreen extends Component {
  handleTabChange = (tab) => {
    const { setModelsVisible } = this.props;

    setModelsVisible(tab);
  };

  render() {
    const { city, isPremium, showModel, videos } = this.props;

    return (
      <Screen
        title={`${videos.length} Videos`}
        isActive
        className="screen--models"
        noFooter
        large
        full
      >
        <div className="screen__tabs u-clearfix">
          <Tabs
            items={MODELS_TABS}
            selected="videos"
            onChange={this.handleTabChange}
            className="u-fl"
          />
        </div>
        {!videos.length && (
          <Message
            text={"No videos yet in " + city.name}
            icon="play_circle_outline"
          />
        )}
        <ol className="o-layout o-layout--tiny u-mb-small videos videos--expanded">
          {videos.map(
            ({ id, createdAt, expired, contentId, thumbnail, model }) => (
              <li key={String(id)} className="o-layout__item u-1/2 u-1/4@m">
                <a
                  className={cx("video", {
                    "modelItem--offline": !model.online,
                  })}
                  onClick={() =>
                    playVideo(
                      contentId,
                      expired && city.video_premium && !isPremium
                    )
                  }
                >
                  <div className="modelItem__dot" />
                  <i className="icon icon--large icon-play_circle_outline" />
                  <img src={thumbnail} />
                </a>
                <div className="u-mv-tiny" style={{ lineHeight: 1 }}>
                  <a onClick={() => showModel(model.id)}>{model.name}</a>
                  <br />
                  <small>
                    {distanceInWordsToNow(new Date(createdAt * 1000))} ago
                  </small>
                </div>
              </li>
            )
          )}
        </ol>
      </Screen>
    );
  }
}

// @connect
import { connect } from "react-redux";
import { getCity, getVideos, isPremiumIn } from "../selectors";
import {
  setModelsVisibleAction,
  showModelAction,
} from "../modules/models/actions";

const props = (state) => {
  const city = getCity(state);
  const isPremium = isPremiumIn(state);
  const videos = getVideos(state);

  return {
    city,
    isPremium,
    videos,
  };
};

const actions = {
  setModelsVisible: setModelsVisibleAction,
  showModel: showModelAction,
};

export default connect(
  props,
  actions
)(VideosScreen);
